import React, { useState, useEffect } from 'react'

import { InputMask } from 'primereact/inputmask'
import { message } from 'antd'

import { getMessage } from '../../../../util/IntlMessages'
import './Styles.css'

const PhoneInput = ({
  handleSubmit = (val) => val,
  confirmButton,
  title = getMessage('landing-page.phone-input.label'),
  placeholder = getMessage('landing-page.phone-input.placeholder'),
  inputStyle
}) => {
  const [phone, setPhone] = useState('')
  const [mask, setMask] = useState('(11) 1111-1111')

  useEffect(() => {
    maskBuilder()
  }, [phone])

  function handleClick() {
    const formattedPhone = phone.replace(/[^a-zA-Z0-9 ]/g, '').replace(' ', '')

    if (formattedPhone.length !== 11 && formattedPhone.length !== 10) {
      return message.error(getMessage('landing-page.phone-input.error'))
    }

    handleSubmit(formattedPhone)
  }

  function renderButton() {
    let button = (
      <button className="button" onClick={handleClick}>
        {getMessage('landing-page.phone-input.submit')}
      </button>
    )
    if (confirmButton) {
      button = <div onClick={handleClick}>{confirmButton}</div>
    }
    return button
  }

  const ajusta = (value) => {
    const digitos = !value ? '' : value.replace(/[^\d]/g, '')
    if (!digitos || digitos.length < 10) return value
    const corte = digitos.length === 10 ? 6 : 7
    const max = digitos.length > 11 ? 11 : digitos.length
    return `(${digitos.substring(0, 2)}) ${digitos.substring(2, corte)}-${digitos.substring(corte, max)}`
  }
  const maskBuilder = () => {
    if (!phone || phone.length === 0) return '(11) 1111-1111'
    const a = ajusta(phone)
    const newMask = a.length >= 6 && a[5] === '9' ? '(11) 11111-1111' : '(11) 1111-1111'
    setMask(newMask)
  }

  return (
    <div className="phone-input">
      <label className="label">{title}</label>
      <InputMask
        className="input"
        type="tel"
        id="phone"
        placeholder={placeholder}
        value={phone}
        onBlur={() => {
          const digitedNumbers = phone.replace(/[^\d]/g, '')
          if (digitedNumbers.length === 10) {
            setMask('(11) 1111-1111')
          }
        }}
        mask={mask}
        style={inputStyle}
        onChange={({ target }) => {
          setPhone(target.value)
        }}
      ></InputMask>
      {renderButton()}
    </div>
  )
}

export default PhoneInput
